import React, { useMemo } from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { AppView } from 'design-system';
import { styles as textStyles } from 'design-system/Text';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { useAutoFocusInput } from 'hooks/useAutoFocusInput';
import StatusBar from 'design-system/StatusBar';
import { KeyboardAvoidingContainerNew } from 'design-system/KeyboardAvoidingContainerNew';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
import Hero from './Hero';
const TextInputView = ({ title, subTitle, type, value, placeholder, autoComplete, onChange, onPressContinue, textRef, isFetching, maxLength, autocapitalize, spellCheck = true, }) => {
    const colors = useColors();
    const fontStyle = useMemo(() => {
        if (value.length >= 15) {
            return fontStyles.small;
        }
        if (value.length >= 10 && value.length < 15) {
            return fontStyles.medium;
        }
        return fontStyles.large;
    }, [value]);
    const styles = useStyles(styleSet);
    useAutoFocusInput(textRef);
    return (<AppView type="primary" avoidHeader style={styles.container}>
      <StatusBar animated barStyle="dark-content"/>
      <KeyboardAvoidingContainerNew flexContainer withButtonSpace>
        <Hero title={title} subTitle={subTitle} OffBlack/>
        <View style={[styles.container, styles.textContainer]}>
          <TextInput value={value} ref={textRef} style={[styles.text, styles.textOffBlack, fontStyle]} keyboardType={type} placeholder={placeholder} placeholderTextColor={colors.text.placeholder} selectionColor={colors.text.selection} onChangeText={onChange} textAlign="center" importantForAutofill="yes" underlineColorAndroid="transparent" returnKeyType="next" autoComplete={autoComplete} autoCorrect={false} spellCheck={spellCheck} allowFontScaling={false} autoCapitalize={autocapitalize || type === 'email-address' ? 'none' : 'words'} onSubmitEditing={onPressContinue} testID="textInput" maxLength={maxLength}/>
        </View>
      </KeyboardAvoidingContainerNew>
      <KeyboardAvoidingButton brand title="Continue" onPress={onPressContinue} isFetching={isFetching} withFrame={false}/>
    </AppView>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
    },
    textContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        color: colors.text.white,
        textAlign: 'center',
        width: '100%',
    },
    textOffBlack: {
        color: colors.text.primary,
    },
}));
// The text styles' font family and size, without their line height. Don't override
// the line height with `lineHeight: undefined` instead: on the New Architecture,
// Android applies that as a line height of 0 and the typed text disappears.
const fontStyles = StyleSheet.create({
    large: {
        fontFamily: textStyles.TextThin_32.fontFamily,
        fontSize: textStyles.TextThin_32.fontSize,
    },
    medium: {
        fontFamily: textStyles.TextThin_24.fontFamily,
        fontSize: textStyles.TextThin_24.fontSize,
    },
    small: {
        fontFamily: textStyles.TextThin_20.fontFamily,
        fontSize: textStyles.TextThin_20.fontSize,
    },
});
export default TextInputView;
